import { useEffect, useRef } from "react";
import { NextRouter } from "next/router";

type Props = {
  router: NextRouter;
  inviteTokenParam: string | string[] | undefined;
  setPhone: (value: string) => void;
  setIsLoginMethodShow: (value: boolean) => void;
  setIsPhoneShow: (value: boolean) => void;
  setIsOtpShow: (value: boolean) => void;
  setIsProfileShow: (value: boolean) => void;
};

export const useInviteTokenHandler = ({
  router,
  inviteTokenParam,
  setPhone,
  setIsLoginMethodShow,
  setIsPhoneShow,
  setIsOtpShow,
  setIsProfileShow,
}: Props) => {
  const processedInviteTokenRef = useRef<string | null>(null);

  useEffect(() => {
    if (!router.isReady) return;
    if (!inviteTokenParam || Array.isArray(inviteTokenParam)) return;
    if (processedInviteTokenRef.current === inviteTokenParam) return;

    try {
      const decodedPayload = decodeInviteToken(inviteTokenParam);
      if (!decodedPayload?.phone) {
        processedInviteTokenRef.current = inviteTokenParam;
        return;
      }

      const normalizedPhone = decodedPayload.phone
        .replace(/\\D/g, "")
        .slice(-10);

      if (normalizedPhone.length !== 10) {
        processedInviteTokenRef.current = inviteTokenParam;
        return;
      }

      setPhone(normalizedPhone);
      setIsLoginMethodShow(false);
      setIsPhoneShow(true);
      setIsOtpShow(false);
      setIsProfileShow(false);
      processedInviteTokenRef.current = inviteTokenParam;
    } catch {
      processedInviteTokenRef.current = inviteTokenParam;
    }
  }, [
    router.isReady,
    router,
    inviteTokenParam,
    setPhone,
    setIsLoginMethodShow,
    setIsPhoneShow,
    setIsOtpShow,
    setIsProfileShow,
  ]);
};

type InviteTokenPayload = {
  phone?: string;
  [key: string]: unknown;
};

const decodeInviteToken = (token: string): InviteTokenPayload | null => {
  try {
    const normalized = token.replace(/-/g, "+").replace(/_/g, "/");
    const padded =
      normalized + "=".repeat((4 - (normalized.length % 4 || 4)) % 4);

    let decoded: string;
    if (typeof window !== "undefined" && window.atob) {
      decoded = window.atob(padded);
    } else if (globalThis?.Buffer?.from) {
      decoded = globalThis.Buffer.from(padded, "base64").toString("utf-8");
    } else {
      return null;
    }

    return JSON.parse(decoded) as InviteTokenPayload;
  } catch {
    return null;
  }
};
